import type { FunctionComponent } from 'react';
import React from 'react';
import { SolidButton, TextButton } from '@noths/polaris-client-ribbons-design-system';
import type { SerializedError } from '@reduxjs/toolkit';
import type { NextRouter } from 'next/router';
import { useRouter } from 'next/router';

import { FILTER_CONTROLS_CLOSE } from '../constants/copy';
import {
  FILTER_CONTROLS_RESET_BUTTON,
  FILTER_CONTROLS_VIEW_RESULTS_BUTTON,
} from '../constants/elementIds';
import * as styles from '../styles/FilterControls.styles';
import * as modalStyles from '../styles/FilterModal.styles';

export interface Props {
  resetText: string;
  isDisabled?: boolean;
  isLoading: boolean;
  totalSelectedFilterOptionsCount: number;
  totalProducts: number;
  onViewResults: VoidFunction;
  onReset: (router: NextRouter) => void;
  error?: SerializedError | null;
}
export const FilterControls: FunctionComponent<Props> = ({
  resetText,
  isDisabled,
  isLoading,
  totalSelectedFilterOptionsCount,
  totalProducts,
  onViewResults,
  onReset,
  error,
}: Props) => {
  const router = useRouter();

  return (
    <div css={modalStyles.modalSectionControls} aria-hidden={isDisabled}>
      <div css={styles.resetButtonWrapper}>
        <TextButton
          id={FILTER_CONTROLS_RESET_BUTTON}
          data-testid={FILTER_CONTROLS_RESET_BUTTON}
          disabled={isDisabled}
          onClick={(e) => {
            e.preventDefault();
            onReset(router);
          }}
        >
          {resetText}
        </TextButton>
      </div>
      <SolidButton
        id={FILTER_CONTROLS_VIEW_RESULTS_BUTTON}
        data-testid={FILTER_CONTROLS_VIEW_RESULTS_BUTTON}
        disabled={isDisabled}
        onClick={onViewResults}
        loading={isLoading}
        fullWidth
      >
        {totalSelectedFilterOptionsCount > 0 && !error
          ? `View ${totalProducts} products`
          : FILTER_CONTROLS_CLOSE}
      </SolidButton>
    </div>
  );
};
